<template>
  <div class="pk-match">
    <em class="close cursor" @click="close"></em>
    <header class="title">
      <transition name="zoomOut">
        <img
          v-show="pkData.state==='matching'"
          src="../../../../assets/img/video/pk/tit_con_1.png"
          alt
        />
      </transition>
      <transition name="zoomIn">
        <img
          v-show="pkData.state==='matched'"
          src="../../../../assets/img/video/pk/tit_con_2.png"
          alt
        />
      </transition>
      <span class="hint" v-if="closeTime">{{closeTime}}s自动关闭</span>
    </header>
    <section>
      <div class="left">
        <div class="red-lottie"></div>
        <div class="red-box">
          <img src="../../../../assets/img/video/pk/red_limi.png" alt />
          <span>{{(!smallClassId && internal_users)?"内部班":smallClassName}}</span>
        </div>
      </div>
      <div class="right">
        <div class="blue-lottie"></div>
        <div class="blue-box"> 
          <span>
            <i v-for="(name,index) in smallClassList" :class="{'scroll-anim':pkData.recv_unique_id}" :key="index">{{name}}</i>
          </span>
          <transition name="blueLimiIn">
            <img  v-show="pkData.state==='matched'" src="../../../../assets/img/video/pk/blue_limi.png" alt />
          </transition>
          <img  v-show="pkData.state==='matching'" class="default_img" src="../../../../assets/img/video/pk/limi_head.png" alt />
        </div>
      </div>
      <transition name="vsIn">
        <img
          v-show="pkData.state==='matched'"
           class="vs" src="../../../../assets/img/video/pk/vs.png"
          alt
        />
      </transition>
    </section>
    <p class="footer">
      参与互动问答获得
      <em>团队积分</em>，得高分的班级获胜
    </p>
  </div>
</template>

<script>
import lottie from "lottie-web-limi";
import { mapState } from "vuex";
export default {
  name: "pk-match",
  data() {
    return {
      smallClassList:[
        "双子班",
        "追梦班",
        "晨星班",
        "智行班",
        "诚学班",
        "砺志班",
        "敏学班",
        "智慧班"
      ]
    };
  },
  computed:{
    ...mapState(["smallClassName","smallClassId","internal_users"])
  },
  props: ["pkData","closeTime"],
  mounted() {
    this.init();
  },
  methods: {
    init(){
      if(this.pkData.recv_unique_id){
        this.smallClassList.push(this.pkData.adversary_small_name)
        this.$nextTick(()=>{
          this.redLottieInit();
          this.$emit("playAudio");
          setTimeout(() => {
            this.$emit('closeInterval',8);
            this.blueLottieInit();
          }, 1600);
        })
      }else{
        this.redLottieInit();
        this.$emit('closeInterval',8);
        this.blueLottieInit();
        this.smallClassList = [this.pkData.adversary_small_name]
      }
    },
    redLottieInit() {
      this.redAnim = lottie.loadAnimation({
        container: document.querySelector(".red-lottie"), // the dom element that will contain the animation
        renderer: "svg", //svg,canvas
        loop: true,
        autoplay: true,
        path: "/static/lottie/pk/red/index.json"
      });
    },
    blueLottieInit() {
      this.blueAnim = lottie.loadAnimation({
        container: document.querySelector(".blue-lottie"), // the dom element that will contain the animation
        renderer: "svg", //svg,canvas
        loop: true,
        autoplay: true,
        path: "/static/lottie/pk/blue/index.json"
      });
    },
    close() {
      this.$emit("close");
      this.redAnim && this.redAnim.destroy();
      this.blueAnim && this.blueAnim.destroy();
    }
  },
  beforeDestroy() {
    this.redAnim && this.redAnim.destroy();
    this.blueAnim && this.blueAnim.destroy();
  }
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.zoomIn-enter-active,
.zoomIn-enter {
  opacity: 0;
  animation: zoomIn 0.4s .6s cubic-bezier(0.645, 0.045, 0.15, 1);
}
.zoomOut-leave-active, .zoomOut-leave-to /* .fade-leave-active below version 2.1.8 */ {
  animation: zoomIn 0.4s reverse cubic-bezier(0.645, 0.045, 0.15, 1);
}

.blueLimiIn-enter-active,
.blueLimiIn-enter {
  animation: blueLimiIn 0.8s cubic-bezier(0.645, 0.045, 0.15, 1);
}
.vsIn-enter-active,
.vsIn-enter {
  animation: vsIn .4s .8s ease;
  opacity: 0;
}
.pk-match {
  position: relative;
  width: 660px;
  height: 428px;
  background: #ffffff;
  border-radius: 15px;
}
.close {
  position: absolute;
  right: -40px;
  top: -40px;
  width: 43px;
  height: 43px;
  background: url("../../../../assets/img/common/close.png") no-repeat;
  background-size: cover;
}
.title {
  position: relative;
  width: 100%;
  height: 95px;
  background: url("../../../../assets/img/video/pk/tit_bg.png") no-repeat;
  background-size: cover;
  img {
    position: absolute;
    height: 50px;
    top: 22px;
    left: 50%;
    transform: translateX(-50%);
  }
  img:nth-child(1) {
    width: 505px;
  }
  img:nth-child(2) {
    width: 430px;
  }
  span {
    position: absolute;
    right: 15px;
    top: 15px;
    color: #ffffff;
  }
}
section {
  padding: 80px 0 40px 0;
  display: flex;
  .vs {
    width: 96px;
    height: 88px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -33%);
    z-index: 3;
  }
  .left,
  .right {
    width: 50%;
    position: relative;
  }
  .red-box,
  .blue-box {
    position: relative;
    z-index: 2;
  }
  .red-lottie,
  .blue-lottie {
    width: 210px;
    height: 100px;
    position: absolute;
    z-index: 1;
    top: -30px;
  }
  .blue-lottie {
    right: 0;
  }
  .red-box span,
  .blue-box span {
    position: absolute;
    font-size: 22px;
    color: #ffffff;
    width: 130px;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    top: 30px;
    height: 30px;
  }
  .red-box {
    transform: translateX(30px);
    background: url("../../../../assets/img/video/pk/red_bg.png") no-repeat;
    background-size: cover;
    text-align: left;
    img {
      margin: -24px 0 0 17px;
      width: 135px;
    }
  }
  .blue-box {
    transform: translateX(-30px);
    background: url("../../../../assets/img/video/pk/blue_bg.png") no-repeat;
    background-size: cover;
    text-align: right;
    img {
      margin: -24px 13px 0 0;
      width: 135px;
    }
    .default_img {
      width: 93px;
      margin-right: 35px;
      transform: translateY(35px);
      animation: matchingAni 2s ease;
    }
    span {
      left: 55px;
      i{
        width: 100%;
        display: block;
        height:30px;
        overflow: hidden;
      }
      .scroll-anim{
        animation: scrollAni 1.5s linear .6s both;
      }
    }
  }
  .red-box,
  .blue-box {
    width: 330px;
    height: 130px;
  }
}
.footer {
  color: #4c7c93;
  font-size: 20px;
  em {
    background: url("../../../../assets/img/common/energy.png") no-repeat left
      center;
    background-size: 24px;
    padding-left: 26px;
    color: #2fa182;
    font-size: 22px;
  }
}
@keyframes scrollAni {
  to{
    transform: translateY(-240px);
  }
  from{
    transform: translateY(0);
  }
}
@keyframes matchingAni {
  0% {
    transform: translateY(20px);
  }
  20% {
    transform: translateY(35px);
  }
  40% {
    transform: translateY(30px);
  }
  60% {
    transform: translateY(35px);
  }
  80% {
    transform: translateY(30px);
  }
  100% {
    transform: translateY(35px);
  }
}
@keyframes blueLimiIn {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  70% {
    transform: scale(0.9);
  }
  90% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes vsIn {
  0% {
    transform: translate(-50%, -33%) scale(4);
  }
  100% {
    transform: translate(-50%, -33%) scale(1);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/video/pk/pkMatch.vue